import { ETableEditAction } from "../../Utils/Enums";
import { endpoints } from "../../Utils/UrlEnum";
import { formatDate } from "../../Utils/Utils";
import { Vocabulary } from "../../Utils/Vocabulary";
import MUIDataTableCustomStyle from "../MUIDataTableCustomStyle";

export default function ClientBooks(props: {
  clientId: string;
  triggerReload: boolean;
}) {
  const { clientId, triggerReload } = props;
  const endPointUrl = `${endpoints.bookSales}/forClient/${clientId}/`;

  /**
   *
   */
  const columns = [
    {
      label: Vocabulary.name,
      name: "bookId",
      options: {
        sort: false,
        customBodyRender: (object: any) => {
          return object?.name;
        },
      },
    },
    {
      label: Vocabulary.quantity,
      name: "quantity",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.purchasedAt,
      name: "createdAt",
      options: {
        sort: false,
        customBodyRender: (object: any) => {
          return formatDate(object);
        },
      },
    },
  ];
  return (
    <div>
      <MUIDataTableCustomStyle
        CRUDEndPoint={endPointUrl}
        title={""}
        onEditAction={ETableEditAction.NONE}
        columns={columns}
        triggerReload={triggerReload}
        hideEditButton
        hideDeleteButton
        hideAddButton
        hideSearch
        // triggerReload={triggerReload}
      />
    </div>
  );
}
